import { Injectable } from "@angular/core";
import { InsightProvider } from "../telephony.provider";
import { FunctionLifeCycle } from "../telephonyutils";
import { HttpClient } from "@angular/common/http";
import { CallStats } from "../../../features/insight/interfaces/Dashboard";

@Injectable({ providedIn: 'root' })
export class TwilioInsightProvider extends InsightProvider {
    constructor(private httpClient: HttpClient) {
        super();
    }
    override init(lifecyle: FunctionLifeCycle): void {
        throw new Error("Method not implemented.");
    }
    clientStats(lifecyle: FunctionLifeCycle, from: string, to: string, campaign: any) {
        let url = `/calls/stats?StartDate=${from}&EndDate=${to}`;
        if (campaign.Code !== 'All') {
            url += `&CampaignId=${campaign.Id}`;
        }
        return this.httpClient.disableLoader().get<CallStats>(url);
    }
    override forceLogOff(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]) {
        throw new Error("Method not implemented.");
    }

}